import React from "react";
import { ThreeBounce } from "better-react-spinkit";

export function BasicLoader(props) {
  return (
    <div className="text-center">
      <ThreeBounce
        color={props.color ? props.color : "var(--vm-primary-colour)"}
        size={props.size ? props.size : 15}
      />
    </div>
  );
}

export default BasicLoader;
